import { Place } from '~/models/Place'
import { PlaceRepository } from './repository'

export class PlaceService {
	static async getPlaceBy(id: string): Promise<Place> {
		return await PlaceRepository.retrievePlace(id)
	}
}
